export type Quality = "high" | "medium" | "low";

/** Reduce drawing cost only; world geometry and simulation remain identical. */
export function qualityResolution(base: number, quality: Quality): number {
	if (quality === "medium") return Math.min(base * 0.75, 1);
	if (quality === "low") return Math.min(base * 0.5, 0.75);
	return base;
}

export function ambientParticleDelay(quality: Quality): number {
	return quality === "high" ? 1 : quality === "medium" ? 2 : Infinity;
}
